// Brand configuration — logos aligned with tahsis-frontend (Approva)
export const USE_FIDOST_BRANDING = true;

export const BRAND_CONFIG = {
  name: USE_FIDOST_BRANDING ? 'Fidost' : 'DPG Finance',
  tagline: USE_FIDOST_BRANDING ? 'Digital Finance Solutions' : 'Digital Payment Guarantee',
  // Light background → logo2; dark background → logo-dark (same as tahsis Login / App shell)
  logo: '/logo2.webp',
  logoWhite: '/logo-dark.webp',
  appName: USE_FIDOST_BRANDING ? 'Fidost' : 'DPG Finance',
  favicon: '/favicon.ico',
  shortName: USE_FIDOST_BRANDING ? 'Fidost' : 'DPG',
};

export const getLogoSrc = (darkMode) => (darkMode ? BRAND_CONFIG.logoWhite : BRAND_CONFIG.logo);
